export function getFormattedPathName(path: string) {
  return (
    path
      .replace(/^\/\/|^\//, '')
      .split('/')
      .filter((t) => !t.match(/^:.*/))
      .join('_') || 'home'
  );
}
